import { connect } from 'react-redux';
import Playbooks from './components/Playbooks';
import { updateUserProfile } from '../../redux/actions/user';
import {
  loadSplunk,
  updateSplunk,
  saveSplunk,
  deleteSplunk,
} from '../../redux/actions/integrations';
import {
  loadPlaybooks,
  loadPlaybooksLogs,
  updatePlaybooks,
  savePlaybooks,
  deletePlaybooks,
  runPlaybooks,
} from '../../redux/actions/playbooks';
import { loadUser } from '../../redux/actions/user';
import { loadFilterProfiles, loadFilters } from '../../redux/actions/filters';
import { selectFilterProfiles } from '../../redux/selectors/filters';

const mapStateToProps = (state) => ({
  token: state.auth.token,
  user: state.user.user,
  //organization: state.user.organization,
  status: state.user.status,
  splunkSettings: state.integration.splunkSettings,
  playbooksSettings: state.playbooks.playbooksSettings,
  playbooksLogs: state.playbooks.playbooksLogs,
  playbooksStatus: state.playbooks.playbooksStatus,
  userFilterProfiles: selectFilterProfiles(state),
});

const mapDispatchToProps = {
  updateUserProfile,
  //updateOrganization,
  loadSplunk,
  updateSplunk,
  saveSplunk,
  deleteSplunk,
  loadUser,
  loadPlaybooks,
  loadPlaybooksLogs,
  updatePlaybooks,
  savePlaybooks,
  deletePlaybooks,
  runPlaybooks,
  loadFilterProfiles,
  loadFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(Playbooks);
